var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmoji = function SvgEmoji(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.4375 34.375C51.0263 34.375 53.125 32.2763 53.125 29.6875C53.125 27.0987 51.0263 25 48.4375 25C45.8487 25 43.75 27.0987 43.75 29.6875C43.75 32.2763 45.8487 34.375 48.4375 34.375Z",
    fill: "#030F40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5625 34.375C29.1513 34.375 31.25 32.2763 31.25 29.6875C31.25 27.0987 29.1513 25 26.5625 25C23.9737 25 21.875 27.0987 21.875 29.6875C21.875 32.2763 23.9737 34.375 26.5625 34.375Z",
    fill: "#030F40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 43.75C30.2188 43.75 24 48.2813 21.5 54.6875H26.7188C28.875 50.9687 32.875 48.4375 37.5 48.4375C42.125 48.4375 46.0937 50.9687 48.2812 54.6875H53.5C51 48.2813 44.7812 43.75 37.5 43.75V43.75ZM37.4687 6.25C20.2187 6.25 6.25 20.25 6.25 37.5C6.25 54.75 20.2187 68.75 37.4687 68.75C54.75 68.75 68.75 54.75 68.75 37.5C68.75 20.25 54.75 6.25 37.4687 6.25ZM37.5 62.5C23.6875 62.5 12.5 51.3125 12.5 37.5C12.5 23.6875 23.6875 12.5 37.5 12.5C51.3125 12.5 62.5 23.6875 62.5 37.5C62.5 51.3125 51.3125 62.5 37.5 62.5Z",
    fill: "#030F40"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmoji, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/emoji.284b5102.svg";
export { ForwardRef as ReactComponent };